// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ffd74ebf","58":"3992ffc2","94":"31612b65","195":"02039a16","263":"c1033551","372":"79b1ba9b","378":"1f115f82","453":"1afe30a8","486":"a37f425b","584":"3e563732","592":"7fd0ad82","682":"a73ab4ad","993":"542de439"}[chunkId] + ".chunk.js";
};